export enum PickerItemKind {
  User = 'user',
  Group = 'group',
}

export type PickerUser = { kind: PickerItemKind.User; uuid: string; name: string; email?: string };

export type PickerGroup = { kind: PickerItemKind.Group; uuid: string; name: string; memberCount: number };

export type PickerValue = PickerUser | PickerGroup;

export enum PickerCategory {
  Users = 'users',
  Groups = 'groups',
}

export enum PickerNavKind {
  Category = 'category',
  Back = 'back',
  Loading = 'loading',
  Empty = 'empty',
}

export type PickerNavOption =
  | { kind: PickerNavKind.Category; category: PickerCategory }
  | { kind: PickerNavKind.Back }
  | { kind: PickerNavKind.Loading }
  | { kind: PickerNavKind.Empty; message: string };

export type PickerOption = PickerValue | PickerNavOption;

const NAV_KINDS = new Set<string>(Object.values(PickerNavKind));

export const isNavOption = (option: PickerOption): option is PickerNavOption => NAV_KINDS.has(option.kind);

export const isDisabledOption = (option: PickerOption): boolean =>
  option.kind === PickerNavKind.Loading || option.kind === PickerNavKind.Empty;

export const isPickerUser = (option: PickerValue): option is PickerUser => option.kind === PickerItemKind.User;

export const memberLabel = (count: number): string => `${count} ${count === 1 ? 'member' : 'members'}`;

export const pickerOptionKey = (option: PickerOption): string => {
  if (option.kind === PickerNavKind.Category) {
    return `category-${option.category}`;
  }
  return isNavOption(option) ? option.kind : `${option.kind}-${option.uuid}`;
};

export type PickerMode = 'root' | PickerCategory;

export const groupSelectionKey = (groupUuids: string[]): string => [...groupUuids].sort().join(',');

export const groupUuidsOf = (value: PickerValue[]): string[] =>
  value.filter((item) => item.kind === PickerItemKind.Group).map((item) => item.uuid);
